import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, withKeys as _withKeys, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "mt-3" }
const _hoisted_3 = { class: "card mb-4" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "list-group" }
const _hoisted_11 = ["data-testid"]
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "mr-2" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["id"]
const _hoisted_16 = ["data-testid"]
const _hoisted_17 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_18 = { class: "d-flex gap-2" }
const _hoisted_19 = ["data-testid", "onClick"]
const _hoisted_20 = ["data-testid", "onClick"]
const _hoisted_21 = ["data-testid", "form"]
const _hoisted_22 = ["data-testid"]

import { ref, computed, onMounted, nextTick } from 'vue'
    import { useRoute } from 'vue-router'
    import CorporateNavigation from "@common/Components/CorporateNavigation.vue"

    import type { ProjectPhaseDefinitionsPageReadModel, ProjectPhaseDefinitionReadModel } from '@Quest/Strategies/readmodels'
    import { useProjectPhaseDefinitionsPageQueryV1 } from '@Quest/Strategies/queries-vue-composables'
    import { useCreateProjectPhaseDefinitionCommandV1, useDeleteProjectPhaseDefinitionCommandV1, useRenameProjectPhaseDefinitionCommandV1 } from '@Quest/Strategies/commands-vue-composables'
    import { guid } from '@common/Guid'
    import type { ValidationError } from '@common/types'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectPhaseDefinitionsPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const strategyId = computed(() => String(route.params.strategyId ?? ''))

    const newPhaseName = ref("")
    const newPhaseId = ref(guid())
    const insertAfterId = ref<string | null>(null)

    const editingId = ref<string | null>(null)
    const editName = ref("")
    const renameInputs = ref<Record<string, HTMLInputElement | null>>({})


    const {
        runProjectPhaseDefinitionsPageQueryV1,
        modelProjectPhaseDefinitionsPageQueryV1
    } = useProjectPhaseDefinitionsPageQueryV1(workspaceId, strategyId)

    const rm = computed(() => modelProjectPhaseDefinitionsPageQueryV1.value as ProjectPhaseDefinitionsPageReadModel)

    const {
        invokeCreateProjectPhaseDefinitionCommandV1,
        validationErrorsCreateProjectPhaseDefinitionCommandV1: createErrors,
        onSucceedCreateProjectPhaseDefinitionCommandV1
    } = useCreateProjectPhaseDefinitionCommandV1(workspaceId, strategyId, newPhaseId, newPhaseName, insertAfterId)

    const {
        invokeDeleteProjectPhaseDefinitionCommandV1,
        onSucceedDeleteProjectPhaseDefinitionCommandV1
    } = useDeleteProjectPhaseDefinitionCommandV1(workspaceId, strategyId)

    const {
        invokeRenameProjectPhaseDefinitionCommandV1,
        validationErrorsRenameProjectPhaseDefinitionCommandV1: renameErrors,
        onSucceedRenameProjectPhaseDefinitionCommandV1
    } = useRenameProjectPhaseDefinitionCommandV1(workspaceId, strategyId, editingId, editName)

    function getError(errors: ValidationError[] | undefined, context: string)
    {
        return (errors ?? []).find(e => e.Context === context)?.Error
    }

    const createNameError = computed(() => getError(createErrors.value, "Name"))
    const renameNameError = computed(() =>
    {
        if (!editingId.value) return null
        return getError(renameErrors.value, "Name")
    })


    function handleDeleteProjectPlanTemplateCommand(t: ProjectPhaseDefinitionReadModel)
    {
        if (confirm("Are you sure?"))
        {
            invokeDeleteProjectPhaseDefinitionCommandV1({ ProjectPhaseDefinitionId: t.Id })
        }
    }

    function createPhase()
    {
        invokeCreateProjectPhaseDefinitionCommandV1()
    }

    function startRename(p: ProjectPhaseDefinitionReadModel)
    {
        editingId.value = p.Id
        editName.value = p.Name
        renameErrors.value = []

        nextTick(() =>
        {
            const input = renameInputs.value[p.Id]
            input?.focus()
            input?.select()
        })
    }

    function setRenameInputRef(id: string)
    {
        return (el: HTMLInputElement | null) =>
        {
            renameInputs.value[id] = el
        }
    }

    function cancelRename()
    {
        editingId.value = null
        renameErrors.value = []
    }

    function confirmRename()
    {
        invokeRenameProjectPhaseDefinitionCommandV1()        
    }

    onMounted(() =>
    {
        document.title = "Project phase definitions"
        runProjectPhaseDefinitionsPageQueryV1()
    })

    onSucceedCreateProjectPhaseDefinitionCommandV1(() =>
    {
        newPhaseId.value = guid()
        newPhaseName.value = ""

        runProjectPhaseDefinitionsPageQueryV1()
    })

    onSucceedDeleteProjectPhaseDefinitionCommandV1(() =>
    {
        runProjectPhaseDefinitionsPageQueryV1()
    })

    onSucceedRenameProjectPhaseDefinitionCommandV1(() =>
    {
        editingId.value = null

        runProjectPhaseDefinitionsPageQueryV1()
    })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CorporateNavigation, { ActivePage: "strategy" }),
    (rm.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"row\"><div class=\"col-lg-6\"><h1 style=\"font-size:2em;font-weight:300;color:#33475b;margin:0;\">Project phase definitions</h1></div><div class=\"col-lg-6 text-right align-self-end\"><!--&lt;button type=&quot;button&quot; class=&quot;btn btn-outline-success&quot; style=&quot;padding: 0.7em 2em;&quot; @click=&quot;showProjectPlanTemplateCreator&quot;&gt;Create a template&lt;/button&gt;--></div></div><hr style=\"border-color:#bbb;margin:20px 0 60px;\">", 2)),
          _createElementVNode("div", _hoisted_2, [
            _createCommentVNode(" Add new phase "),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "mb-3" }, "Add new phase", -1 /* CACHED */)),
                _createElementVNode("form", {
                  onSubmit: _withModifiers(createPhase, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newPhaseName).value = $event)),
                        class: _normalizeClass(["form-control", { 'is-invalid': createNameError.value }]),
                        placeholder: "Phase name",
                        required: "",
                        minlength: "1",
                        "data-testid": "project-phase-definition-name"
                      }, null, 2 /* CLASS */), [
                        [
                          _vModelText,
                          newPhaseName.value,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (createNameError.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(createNameError.value), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((insertAfterId).value = $event)),
                        class: "form-control",
                        "data-testid": "project-phase-definition-insert-after"
                      }, [
                        _cache[3] || (_cache[3] = _createElementVNode("option", { value: null }, "Insert at beginning", -1 /* CACHED */)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rm.value.Definitions, (p) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: p.Id,
                            value: p.Id
                          }, " After " + _toDisplayString(p.Name), 9 /* TEXT, PROPS */, _hoisted_9))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 512 /* NEED_PATCH */), [
                        [_vModelSelect, insertAfterId.value]
                      ])
                    ]),
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-md-4" }, [
                      _createElementVNode("button", {
                        type: "submit",
                        class: "btn btn-success"
                      }, " Add phase ")
                    ], -1 /* CACHED */))
                  ])
                ], 32 /* NEED_HYDRATION */)
              ])
            ]),
            _createCommentVNode(" Existing phases "),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rm.value.Definitions, (p, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: p.Id,
                  class: "list-group-item d-flex justify-content-between align-items-center",
                  "data-testid": `project-phase-definition-row-${index}`
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("strong", _hoisted_13, _toDisplayString(index + 1) + ".", 1 /* TEXT */),
                    (editingId.value !== p.Id)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(p.Name), 1 /* TEXT */))
                      : (_openBlock(), _createElementBlock("form", {
                          key: 1,
                          id: 'rename-form-' + p.Id,
                          class: "d-flex flex-column",
                          onSubmit: _withModifiers(confirmRename, ["prevent"])
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editName).value = $event)),
                            class: _normalizeClass(["form-control rename-input", { 'is-invalid': renameNameError.value }]),
                            style: {"width":"250px"},
                            required: "",
                            minlength: "1",
                            onKeydown: _withKeys(cancelRename, ["esc"]),
                            ref_for: true,
                            ref: setRenameInputRef(p.Id),
                            "data-testid": `project-phase-definition-rename-input-${index}`
                          }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_16), [
                            [
                              _vModelText,
                              editName.value,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (renameNameError.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(renameNameError.value), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_15))
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createCommentVNode(" Normal mode "),
                    (editingId.value !== p.Id)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-outline-primary",
                            "data-testid": `project-phase-definition-rename-${index}`,
                            onClick: ($event: any) => (startRename(p))
                          }, " Rename ", 8 /* PROPS */, _hoisted_19),
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-outline-danger",
                            "data-testid": `project-phase-definition-delete-${index}`,
                            onClick: ($event: any) => (handleDeleteProjectPlanTemplateCommand(p))
                          }, " Delete ", 8 /* PROPS */, _hoisted_20)
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createCommentVNode(" Edit mode "),
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-success",
                            "data-testid": `project-phase-definition-save-${index}`,
                            form: 'rename-form-' + p.Id,
                            type: "submit"
                          }, " Save ", 8 /* PROPS */, _hoisted_21),
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-secondary",
                            "data-testid": `project-phase-definition-cancel-${index}`,
                            type: "button",
                            onClick: cancelRename
                          }, " Cancel ", 8 /* PROPS */, _hoisted_22)
                        ], 64 /* STABLE_FRAGMENT */))
                  ])
                ], 8 /* PROPS */, _hoisted_11))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})